import './index.scss';
import React from 'react';
import GeniusModal from '~/components/genius_modal';
import Button from '~/form_components/button';
const ErrorModal = ({ message, onClose }) => {
    const isDebugLogging = localStorage.getItem('debug-logging') === 'true';
    return (React.createElement(GeniusModal, { alertForm: true, isModalShowing: !!message, onHide: onClose, headerContent: React.createElement("div", { className: 'websocket-error-modal-header' }, "WebSocket Error"), bodyContent: React.createElement("div", { className: 'websocket-error-modal-body' },
            "Please refresh the page or contact support if the problem persists.",
            isDebugLogging &&
                React.createElement("div", { className: 'error-description-wrapper' },
                    React.createElement("b", null, "Error Description: "),
                    message)), footerContent: React.createElement("div", { className: 'websocket-error-modal-footer' },
            React.createElement(Button, { secondary: true, onClick: () => window.location.reload() }, "Refresh")) }));
};
export default ErrorModal;
